<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div>
      <status-information
        class="card has-background-white"
        v-if="!hideStatusInfo"
        :status="data.status"
        :shippingRequest="data"
      ></status-information>
      <shipper-consignee-detail
        class="has-padding-30 card has-background-light has-padding-bottom-80 has-margin-bottom-30"
        :data="data"
      ></shipper-consignee-detail>

      <div
        class="has-padding-30 has-padding-bottom-80 has-margin-bottom-30 card has-background-light"
        v-for="(dangerousGood, index) in data.dangerousGoods"
        :key="index"
      >
        <dangerous-goods :index="index" :data="dangerousGood"></dangerous-goods>
      </div>

      <additional-information class="has-padding-30 card has-background-light" :data="data"></additional-information>
      <activity-information
        class="has-padding-30 card has-background-light"
        v-if="showActivityHistory"
        :activityData="activityData"
      ></activity-information>
      <div class="has-padding-10 card has-background-light">
        <approve-certificate
          v-if="data.status === 'APPROVED'"
          :data="data"
          :activityData="activityData"
        ></approve-certificate>
      </div>
    </div>

    <div
      class="has-padding-top-50 has-padding-bottom-50 card has-background-light flex-row justify-center has-text-weight-bold"
    >End of Application</div>
  </div>
</template>

<script>
import StatusInformation from "./StatusInformation";
import ShipperConsigneeDetail from "./ShipperConsigneeDetail";
import DangerousGoods from "./DangerousGoods";
import AdditionalInformation from "./AdditionalInformation";
import ApproveCertificate from "./ApproveCertificate";
import ActivityInformation from "./ActivityInformation.vue";
import GetActivityHistoryQuery from "@/modules/commonModule/api/graphql/queries/GetActivityHistory.gql";

export default {
  name: "MainDGDetails",
  components: {
    ShipperConsigneeDetail,
    DangerousGoods,
    AdditionalInformation,
    StatusInformation,
    ApproveCertificate,
    ActivityInformation,
  },
  props: {
    data: Object,
    removeStatusInfo: Boolean,
    showActivityHistory: Boolean
  },

  data() {
    return {
      isLoading: false,
      activityData: [],
      printer_off: true
    };
  },

  mounted() {
    if (this.showActivityHistory) {
      this.getActivityHistoryFromAPI();
    }
  },

  computed: {
    hideStatusInfo: function() {
      return this.removeStatusInfo;
    }
  },

  methods: {
    getActivityHistoryFromAPI: function() {
      this.isLoading = true;

      this.$apollo
        .query({
          query: GetActivityHistoryQuery,
          variables: {
            shipping_request_id: this.data.id
          }
        })
        .then(response => {
          const ActivityHistory =
            response.data.GetShippingRequestActivtyHistory;

          this.activityData = ActivityHistory;
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "An error occured trying to retrieve data",
            type: "is-danger"
          });
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
